import React from 'react';

import { Route, Routes } from 'react-router-dom';

import { SecurityCheck } from './routes/SecurityCheck';
import { appRoutes } from '@/configs/appRoutes';

const SecurityCheckRouter = () => (
  <Routes>
    <Route path={appRoutes.ROOT} element={<SecurityCheck />} />
  </Routes>
);

export default SecurityCheckRouter;
